import { gql, useMutation } from '@apollo/client';

import {
  BookingWithArea,
  BookingHooksBasicProps,
  CreateBookingAreaResponse,
} from '@views/shared/interfaces/booking';
import { useBookForMeetingRooms } from '@views/Home/Book/BasicBook/Booking/hooks';
import { useHasFeature } from '@views/shared/hooks/hasFeature';

const createBookingMutation = gql`
  mutation bookMeetingRoom($areaId: ID!, $start: DateTime!, $end: DateTime!) {
    createBooking(booking: { areaId: $areaId, start: $start, end: $end }) {
      id
      start
      end
      area {
        areaType
        name
        floor {
          floorLabel
          floorNumber
          floorType
          building {
            name
            address
          }
        }
      }
    }
  }
`;

export function useBook({
  date,
  enabledHalfDayBooking,
  enabledHourlyBooking,
  hasNextDaysBooking,
  formats,
  params: { areaId },
  t,
  type,
}: BookingHooksBasicProps) {
  const enabledCateringBooking = useHasFeature('booking_catering');
  const mutation = useMutation<
    { createBooking: CreateBookingAreaResponse },
    BookingWithArea
  >(createBookingMutation, {});

  return useBookForMeetingRooms({
    date,
    enabledHalfDayBooking,
    enabledHourlyBooking,
    hasNextDaysBooking,
    t,
    type,
    params: {
      enabledCateringBooking,
      areaId,
    },
    formats,
    bookingMutation: mutation,
  });
}
